import React from 'react';
import { AppBar, Toolbar, Typography, Tabs, Tab } from '@mui/material';

function TopBar({ currentPage, setCurrentPage }) {
  const pages = ['Home',"Map"];

  return (
    <AppBar position="static">
      <Toolbar>
        <Typography variant="h6" sx={{ flexGrow: 1 }}>
          FindMYWay
        </Typography>
        <Tabs
          value={currentPage}
          onChange={(e, val) => setCurrentPage(val)}
          textColor="inherit"
          indicatorColor="secondary"
        >
          {pages.map((page) => (
            <Tab key={page} label={page} value={page} />
          ))}
        </Tabs>
      </Toolbar>
    </AppBar>
  );
}

export default TopBar;
